import script from "./FreeForever.vue?vue&type=script&setup=true&lang=js"
export * from "./FreeForever.vue?vue&type=script&setup=true&lang=js"

import "./FreeForever.vue?vue&type=style&index=0&id=29277f5f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29277f5f"]])

export default __exports__